/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_Errors_Invalid_User_NameInputs */

const nl_auth_password_errors_invalid_user_name = /** @type {(inputs: Auth_Password_Errors_Invalid_User_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeldige gebruikersnaam`)
};

/**

* @param {Auth_Password_Errors_Invalid_User_NameInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_password_errors_invalid_user_name = /** @type {((inputs?: Auth_Password_Errors_Invalid_User_NameInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_Errors_Invalid_User_NameInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_password_errors_invalid_user_name(inputs)
});
export { auth_password_errors_invalid_user_name as "auth.password_errors.invalid_user_name" }